import { render, staticRenderFns } from "./RecebimentoCardList.vue?vue&type=template&id=a2d6ebbc&scoped=true"
import script from "./RecebimentoCardList.vue?vue&type=script&lang=ts"
export * from "./RecebimentoCardList.vue?vue&type=script&lang=ts"
import style0 from "./RecebimentoCardList.vue?vue&type=style&index=0&id=a2d6ebbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d6ebbc",
  null
  
)

export default component.exports